module.exports = __webpack_public_path__ + "images/imgman-f43096cd.svg";